import React, { useCallback, useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../components/breadcrumb";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { usePageQuery } from "../../graphql/page.hooks";
import { QRModal } from "../../components/modals/QRModal";
import { useUserQuery } from "../../graphql/menu.hooks";

export const GetQRCode = () => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const navigate = useNavigate();
  const { pageId } = useParams();
  const { data: page, loading: pageLoading } = usePageQuery({
    variables: { id: +pageId },
  });

  const [showModal, setShowModal] = useState(false);
  const { data: User } = useUserQuery();

  const location = useLocation();
  const sharedValue = location.state?.shared;
  const accessType = page?.page.domain?.userAccesses?.find(
    (user) => user?.user?.email === User?.user.email
  );
  const link = sharedValue || accessType ? `${lng}/shared` : `${lng}/projects`;

  useEffect(() => {
    document.title = "Get QR Code";
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "inherit";
    };
  }, []);

  const paths = [
    {
      label:
        sharedValue || accessType ? t("menu.shared") : t("payment.Projects"),
      path: link,
    },
    {
      label: page?.page.project.title,
      path: `${lng}/projects/${page?.page.project.id}`,
    },
  ];

  const backToProjects = useCallback(() => {
    navigate(`${lng}/projects/${page?.page.project.id}`);
  }, [lng, page, navigate]);

  const isShowAgain = JSON.parse(localStorage.getItem("isShowAgain"));

  useEffect(() => {
    if (isShowAgain === null) {
      localStorage.setItem("isShowAgain", JSON.stringify(true));
    }

    const handleMessage = (event: MessageEvent) => {
      const { type } = event.data;

      if (type === "QR_DOWNLOADED") {
        window.gtag?.("event", "download_qr_code");
        setShowModal(isShowAgain);
      }

      if (type === "BACK_BTN") {
        backToProjects();
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [backToProjects, isShowAgain]);

  if (pageLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t("profile.loading")}...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div>
      <div className="container d-md-flex justify-content-between align-items-baseline">
        <div className="col-8">
          <h1>
            <span className="d-block overflow-ellipsis overflow-hidden text-nowrap">{`${page?.page.title} `}</span>
            {t("qr.pageQR").slice(5)}
          </h1>
          <div className="d-flex mb-3 mb-md-0">
            <Breadcrumb t={t} paths={paths} />
            <span className="text-gray mx-2">{"/"}</span>
            <p className="mb-0 fs-7 text-gray">{t("qr.createQR")}</p>
          </div>
        </div>
        <Button
          onClick={backToProjects}
          className="btn btn-primary text-white col-12 col-lg-2 col-md-4"
        >
          {t("share.back")}
        </Button>
      </div>
      <iframe
        className="col-12 generateQrCodeIframe"
        src={`https://me-qr.com/generator/servise?url=${page?.page.page.publicUrl}&container=1&mepageview=1`}
      ></iframe>
      <QRModal
        show={showModal}
        onConfirm={backToProjects}
        onCancel={() => setShowModal(false)}
      />
    </div>
  );
};
